function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  rx: "15%",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3590c5",
  d: "M56 205h70v127H56z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#c53827",
  d: "M386 198h70v117h-70z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ec8b24",
  d: "M304 172h70v152h-70z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbc618",
  d: "M222 194h70v146h-70z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#612268",
  d: "M139 182h70v141h-70z"
});

function SvgStitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Stitcher",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStitcher);
export default __webpack_public_path__ + "static/media/stitcher.cc15e81f.svg";
export { ForwardRef as ReactComponent };